import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { Utils } from "../../../../../shared/utils/Utils";
import {
  CriterioComportamientoSv,
  CriteriosComportamientoSvService,
} from "../../../../../shared/services/criterios-comportamiento-sv.service";

@Component({
  selector: "app-criterios-comportamiento",
  templateUrl: "./criterios-comportamiento.component.html",
  styleUrls: ["./criterios-comportamiento.component.scss"],
})
export class CriteriosComportamientoComponent implements OnInit {
  criterioForm!: FormGroup;
  activeTab = 1;

  guardando = false;
  cargandoListado = false;
  cargandoEdicion = false;

  criterios: CriterioComportamientoSv[] = [];
  criteriosFiltrados: CriterioComportamientoSv[] = [];

  filtro = "";
  filtroEstado: number | null = null;
  pageSize = 10;
  page = 1;

  modoEdicion = false;
  idCriterioEditando: number | null = null;

  readonly Number = Number;

  constructor(
    private fb: FormBuilder,
    private criteriosService: CriteriosComportamientoSvService,
  ) {}

  ngOnInit(): void {
    this.inicializarFormulario();
    this.cargarCriterios();
  }

  private inicializarFormulario(): void {
    this.criterioForm = this.fb.group({
      criterio: ["", [Validators.required, Validators.maxLength(300)]],
      descripcion: [null],
      peso: [null],
    });
  }

  cargarCriterios(): void {
    this.cargandoListado = true;
    this.criteriosService.getAll().subscribe({
      next: (response: any) => {
        this.criterios = this.normalizarLista(response);
        this.aplicarFiltro();
        this.cargandoListado = false;
      },
      error: () => {
        this.criterios = [];
        this.criteriosFiltrados = [];
        this.cargandoListado = false;
      },
    });
  }

  private normalizarLista(response: any): any[] {
    if (Array.isArray(response)) return response;
    if (Array.isArray(response?.data)) return response.data;
    return [];
  }

  aplicarFiltro(): void {
    const termino = String(this.filtro || "").toLowerCase().trim();

    let filtrados = this.criterios.filter((item) => {
      const coincideTexto =
        !termino || String(item.criterio || "").toLowerCase().includes(termino);
      const estadoItem = Number(item.estado);
      const coincideEstado = this.filtroEstado === null || estadoItem === this.filtroEstado;
      return coincideTexto && coincideEstado;
    });

    filtrados = filtrados.sort((a, b) => {
      const estadoA = Number(a.estado) === 1 ? 0 : 1;
      const estadoB = Number(b.estado) === 1 ? 0 : 1;
      if (estadoA !== estadoB) return estadoA - estadoB;
      return ((a as any).id || 0) - ((b as any).id || 0);
    });

    this.criteriosFiltrados = filtrados;
    this.page = 1;
  }

  guardar(): void {
    if (this.criterioForm.invalid) {
      this.criterioForm.markAllAsTouched();
      Swal.fire("Campos obligatorios", "Completa el criterio antes de guardar.", "warning");
      return;
    }

    const formValue = this.criterioForm.getRawValue();
    const payload: CriterioComportamientoSv = {
      criterio: String(formValue.criterio || "").trim().toUpperCase(),
      descripcion: formValue.descripcion ? String(formValue.descripcion).trim() : null,
      peso: formValue.peso !== null && formValue.peso !== undefined ? Number(formValue.peso) : null,
      estado: 1,
    };

    this.guardando = true;

    const accion$ = this.modoEdicion
      ? this.criteriosService.update(this.idCriterioEditando as number, payload)
      : this.criteriosService.create(payload);

    accion$.subscribe({
      next: () => {
        this.guardando = false;
        Swal.fire("Éxito", `Criterio ${this.modoEdicion ? "actualizado" : "guardado"} correctamente.`, "success");
        this.cancelarEdicion();
        this.cargarCriterios();
        this.activeTab = 2;
      },
      error: (error: any) => {
        this.guardando = false;
        const mensaje = error?.error?.error || "No se pudo guardar el criterio.";
        Swal.fire("Error", mensaje, "error");
      },
    });
  }

  editarCriterio(criterio: CriterioComportamientoSv): void {
    if (Number(criterio?.estado) !== 1) {
      Swal.fire("Info", "Solo se puede editar cuando el registro está activo.", "info");
      return;
    }

    this.modoEdicion = true;
    this.idCriterioEditando = Number((criterio as any).id);

    this.criterioForm.patchValue({
      criterio: criterio.criterio,
      descripcion: criterio.descripcion,
      peso: criterio.peso,
    });

    this.activeTab = 1;
  }

  cancelarEdicion(): void {
    this.modoEdicion = false;
    this.idCriterioEditando = null;
    this.criterioForm.reset({ criterio: "", descripcion: null, peso: null });
  }

  cambiarEstado(criterio: CriterioComportamientoSv, estado: number): void {
    const id = Number((criterio as any).id);
    const accion = estado === 1 ? "activar" : "inactivar";

    Swal.fire({
      title: `¿Deseas ${accion} este criterio?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Sí, ${accion}`,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      const accionServicio =
        estado === 1 ? this.criteriosService.activar(id) : this.criteriosService.inactivar(id);

      accionServicio.subscribe({
        next: () => {
          Swal.fire("Éxito", `Criterio ${accion}do correctamente.`, "success");
          this.cargarCriterios();
        },
        error: (error: any) => {
          const mensaje = error?.error?.error || `No se pudo ${accion} el criterio.`;
          Swal.fire("Error", mensaje, "error");
        },
      });
    });
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }
}